// extracted by mini-css-extract-plugin
export default {"stats":"stats_stats__ulSCQ","stat":"stats_stat__0vVCW"};